// @flow weak

import React        from 'react';

const TodoListAddTask = () => (
  <a
    className="btn btn-success btn-sm pull-left"
    href="#">
    Add New Tasks
  </a>
);

export default TodoListAddTask;



// WEBPACK FOOTER //
// ./src/app/components/todoList/todoListCommands/TodoListAddTask.js